<template>
  <page>
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field v-model="filters.busCls" :label="labels.busCls" :error-messages="errors.collect('busCls')" data-vv-name="busCls" :data-vv-as="labels.busCls" v-validate="'name|max:4'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field v-model="filters.nol1" :label="labels.nol1" :error-messages="errors.collect('nol1')" data-vv-name="nol1" :data-vv-as="labels.nol1" v-validate="'name|max:2'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-layout row wrap>
            <v-spacer></v-spacer>
            <div>
              <v-btn color="primary" @click.native="doNew()">
                New Permitted NOL 1
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
            </div>
          </v-layout>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.busCls }}</td>
                <td>{{ row.item.busClsDesc }}</td>
                <td>{{ row.item.nol1 }}</td>
                <td>{{ row.item.nol1longDesc }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item.busCls, row.item.nol1)" query @query="doQuery(row.item.busCls, row.item.nol1)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <v-dialog v-model="formDialog" width="900px" persistent>
        <v-card>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon v-if="newMode">mdi-plus</v-icon>
            <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
            <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
            <v-toolbar-title v-if="newMode">Create Permitted NOL per Business Class</v-toolbar-title>
            <v-toolbar-title v-else-if="reviewMode">Edit Permitted NOL per Business Class</v-toolbar-title>
            <v-toolbar-title v-else-if="queryMode">Query Permitted NOL per Business Class</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <!-- <message :messages="messages"></message> -->
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-autocomplete :readonly="reviewMode || queryMode" :label="labels.busCls"
                  :items="busClsDropDownList" v-model="form.busCls" item-text="busClsWithDesc" item-value="busCls"
                  data-vv-name="busCls" :data-vv-as="labels.busCls" :error-messages="errors.collect('busCls')" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-text-field readonly v-model="form.busClsDesc" :label="labels.busClsDesc"
                  :error-messages="errors.collect('busClsDesc')" data-vv-name="busClsDesc"
                  :data-vv-as="labels.busClsDesc" v-validate="'max:40'"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-autocomplete :readonly="reviewMode || queryMode" :label="labels.nol1"
                  :items="clmNol1DropDownList" v-model="form.nol1" item-text="nol1WithLongDesc" item-value="nol1"
                  data-vv-name="nol1" :data-vv-as="labels.nol1" :error-messages="errors.collect('nol1')" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-text-field readonly v-model="form.nol1longDesc" :label="labels.nol1longDesc"
                  :error-messages="errors.collect('nol1longDesc')" data-vv-name="nol1longDesc"
                  :data-vv-as="labels.nol1longDesc" v-validate="'max:40'"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs6>
                  <v-text-field :readonly="queryMode" v-model="form.giaType" :label="labels.giaType"
                  :error-messages="errors.collect('giaType')" data-vv-name="giaType" :data-vv-as="labels.giaType" v-validate="'max:2'"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap >
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.createdBy}}</v-subheader>
                  <div class="queryValue">{{createdBy}}</div>
                </v-flex>
                <v-flex xs6 v-if="!newMode">
                  <v-subheader class="queryLabel">{{labels.createdDate}}</v-subheader>
                  <div class="queryValue">{{createdDate}}</div>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{labels.createdDate}}</v-subheader>
                  <div class="queryValue">{{formatDisplayDate(createdDate)}}</div>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="!newMode">
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.modifiedBy}}</v-subheader>
                  <div class="queryValue">{{modifiedBy}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.modifiedDate}}</v-subheader>
                  <div class="queryValue">{{modifiedDate}}</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn color="red" dark class=" mr-2" @click="doCancel" :loading="submitting">
              Cancel
              <v-icon right>mdi-cancel</v-icon>
            </v-btn>
            <v-btn color="primary" v-if="newMode || reviewMode" dark class=" mr-2" @click="doSave" :loading="submitting">
              Save
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Permitted NOL?
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'

export default {
  data() {
    return {
      formDialog: false,
      toogleArray: [false],
      headers: [
        { text: 'Business Class', value: 'busCls' },
        { text: 'Description', value: 'busClsDesc' },
        { text: 'NOL 1', value: 'nol1' },
        { text: 'NOL 1 Long Description', value: 'nol1longDesc' },
        TableConst.tableActionHeader
      ],
      filters: {
        busCls: undefined,
        nol1: undefined
      },
      totalItems: 0,
      selectedBusCls: undefined,
      deleteBusCls: undefined,
      loading: false,
      promptRemove: false,
      labels: {
        busCls: 'Business Class',
        nol1: 'Nature Of Loss 1',
        busClsDesc: 'Description',
        nol1longDesc: 'Long Description',
        giaType: 'GIA Type',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        busCls: '',
        nol1: '',
        busClsDesc: '',
        nol1longDesc: '',
        giaType: ''
      },
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: undefined,
      newMode: false,
      reviewMode: false,
      queryMode: false,
      submitting: false,
      busClsDropDownList: [],
      clmNol1DropDownList: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    },
    busClsWatch(value) {
      if (value !== undefined && value.length > 0) {
        if (this.filterBusCls.length > 0) {
          this.form.busClsDesc = this.filterBusCls[0].busClsDesc
        }
      }
    },
    nol1Watch(value) {
      if (value !== undefined && value.length > 0) {
        if (this.filterNol1.length > 0) {
          this.form.nol1longDesc = this.filterNol1[0].nol1longDesc
        }
      }
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  busCls: datamap.busCls,
                  busClsDesc: datamap.busClsDesc,
                  nol1: datamap.nol1,
                  nol1longDesc: datamap.nol1longDesc
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.busCls = null
      this.filters.nol1 = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doReview(busCls, nol1) {
      this.resetValidator()
      this.resetMessages()
      this.reviewMode = true
      this.newMode = false
      this.queryMode = false
      this.formDialog = true
      this.doFetchData(busCls, nol1)
    },
    doQuery(busCls, nol1) {
      this.resetValidator()
      this.resetMessages()
      this.queryMode = true
      this.newMode = false
      this.reviewMode = false
      this.formDialog = true
      this.doFetchData(busCls, nol1)
    },
    doNew() {
      this.doReset()
      this.resetValidator()
      this.resetMessages()
      this.newMode = true
      this.reviewMode = false
      this.queryMode = false
      this.formDialog = true
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedBusCls = data
        this.deleteBusCls = data.busCls
      }
    },
    doReset() {
      this.form.busCls = ''
      this.form.nol1 = ''
      this.form.busClsDesc = ''
      this.form.nol1longDesc = ''
      this.form.giaType = ''
    },
    async doRemove() {
      const apiURI = this.menu.deletePmtNOL1PerBusCls
      if (apiURI) {
        const expand = this.selectedBusCls
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
          }
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createPmtNOL1PerBusCls
      const form = this.form
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
            this.doInit()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.formDialog = false
    },
    async doUpdate() {
      const apiURI = this.menu.updatePmtNL1PerBusCls
      const form = this.form
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
            this.doInit()
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doFetchBusClsDropDown() {
      const apiURI = this.menu.getBusClsDropDownList
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.busClsDropDownList = []
            const { data } = result.data
            if (data) {
              data.map((busClsMap) => {
                const convertBusClsList = {
                  busCls: busClsMap.busCls,
                  busClsDesc: busClsMap.desc,
                  busClsWithDesc: busClsMap.busCls + ' - ' + busClsMap.desc
                }
                this.busClsDropDownList.push(convertBusClsList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async doFetchClmNol1DropDown() {
      const apiURI = this.menu.getClmNOL1DropDownList
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.clmNol1DropDownList = []
            const { data } = result.data
            if (data) {
              data.map((nol1Map) => {
                const convertNol1List = {
                  nol1: nol1Map.nol1,
                  nol1longDesc: nol1Map.nol1LongDesc,
                  nol1WithLongDesc: nol1Map.nol1 + ' - ' + nol1Map.nol1LongDesc
                }
                this.clmNol1DropDownList.push(convertNol1List)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async doFetchData(busCls, nol1) {
      const apiURI = this.menu.getBusClsClmNOL1
      if (apiURI) {
        this.loading = true
        try {
          const expand = { busCls: busCls, nol1: nol1 }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.form.busCls = data.busClsClmNOL1.busCls
            this.form.busCLlsDesc = data.busClsClmNOL1.busClsDesc
            this.form.nol1 = data.busClsClmNOL1.nol1
            this.form.nol1longDesc = data.busClsClmNOL1.nol1longDesc
            this.form.giaType = data.busClsClmNOL1.giaType
            this.createdBy = data.createdBy
            this.createdDate = formatDisplayDate(data.createdDate)
            this.modifiedBy = data.modifiedBy
            this.modifiedDate = formatDisplayDate(data.modifiedDate)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loading = false
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.pmtNOL1PerBusClsParam.menu
    },
    busClsWatch() {
      return this.form.busCls
    },
    nol1Watch() {
      return this.form.nol1
    },
    filterBusCls() {
      return this.busClsDropDownList.filter((list) => {
        return list.busCls === this.form.busCls
      })
    },
    filterNol1() {
      return this.clmNol1DropDownList.filter((list) => {
        return list.nol1 === this.form.nol1
      })
    }
  },
  mounted() {
    this.doInit(true)
    this.doFetchBusClsDropDown()
    this.doFetchClmNol1DropDown()
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
